const _version = "3.5.1"
function version() {
    return _version
}
export default version
